module.exports = __webpack_public_path__ + "img/icon-edit.e6654111.svg";